export function makeModalAccessible(element: Element): void {
  if (element.getAttribute('role') !== 'alert') {
    element.setAttribute('role', 'alert');
  }

  const productImages = element.querySelectorAll('.tabarnapp__image');
  productImages.forEach((productImage) => {
    productImage.setAttribute('alt', '');
    productImage.setAttribute('role', 'presentation');
  });
}
